module.exports = __webpack_public_path__ + "static/media/screen.06fc2128.svg";